module.exports = __webpack_public_path__ + "assets/img/posture.b4e815b1.png";